var _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoClose(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  var color = props.fillColor || "#0F3951";
  var outlineColor = props.filled ? 'none' : color;
  var filledColor = props.filled ? color : 'none';
  delete props.filled;
  delete props.fillColor;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M27.95,24.75l7.5-7.6c.78-.79,.77-2.05-.02-2.83-.78-.78-2.05-.77-2.83,.02l-7.47,7.57-7.47-7.57c-.78-.79-2.04-.79-2.83-.02-.79,.78-.79,2.04-.02,2.83l7.5,7.6-7.5,7.6c-.78,.79-.77,2.05,.02,2.83,.39,.38,.9,.58,1.4,.58s1.03-.2,1.42-.6l7.47-7.57,7.47,7.57c.39,.4,.91,.6,1.42,.6s1.02-.19,1.4-.58c.79-.78,.79-2.04,.02-2.83l-7.5-7.6Z",
    fill: outlineColor
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoClose);
export default __webpack_public_path__ + "static/media/ico-close.40c9f9d4a0562df4562b1e93c4f00245.svg";
export { ForwardRef as ReactComponent };
ForwardRef.hasFilled = false;